module.exports = __webpack_public_path__ + "img/Linkedin.f3fb2d02.svg";